// extracted by mini-css-extract-plugin
export default {"loading-container":"PreLoader_loading-container__Uwvye","loader":"PreLoader_loader__tWf61"};